import React from 'react';
import { Card as MaterialCard } from '@material-ui/core';
import { CardContent } from './CardContent';
import { CardMedia } from './CardMedia';
import { useCardStyles } from './Card.styled';
export var Card = function (_a) {
    var children = _a.children, onClick = _a.onClick, _b = _a.enableHover, enableHover = _b === void 0 ? false : _b;
    var cardStyles = useCardStyles({
        enableHover: enableHover,
        isOnClickEnabled: !!onClick,
    })();
    return (React.createElement(MaterialCard, { onClick: onClick, classes: cardStyles }, children));
};
Card.Content = CardContent;
Card.Media = CardMedia;
//# sourceMappingURL=Card.js.map